import { schema } from "normalizr"
import technology from "./item"
import technologyItems from "../technologyItems"

export default new schema.Object({
  technology,
  technologyItems,
})
